const serverUrl = 'https://future-e-be.onrender.com/appA';
// const serverUrl = 'http://localhost:8080/appA';
export default serverUrl;